import { Reducer } from 'redux';
import { ImActionTypes, ImsState } from './action';
import { isImageTypeMsg, parseFromConversion, parseCustomImageConversion } from './utils';

const initialState: ImsState = {
  timIsReady: false,
  timIsGroupReady: false,
  userInfo: {
    username: 'za001',
    uuid: '',
  },
  timSdkConfig: {
    id: 0,
    roomId: '',
    sdkappid: '',
    users: [],
    currentConversationID: '',
    currentConversationType: 'GROUP', // 当天聊天类型
  },
  triggerScroll: false,
  timGroupChat: {
    list: [],
    groupPhotoList: [],
    isMore: false,
    nextReqMessageID: '',
    lastMessageTime: Date.now(),
  },
};
const { TIMSDK_DATA_DYNAMIC_UPDATE, TIMSDK_LOGOUT, TIMSDK_UPDATE_CONFIG, TIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST, TIMSDK_RECEIVEMESSAGE, TIMSDK_RECEIVE_MESSAGE_SCROLL, TIMSDK_UPDATE_MESSAGE_STATUS, NIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST, NIMSDK_DATA_DYNAMIC_UPDATE, NIMSDK_RECEIVEMESSAGE } =
  ImActionTypes;
const reducer: Reducer<ImsState> = (state = initialState, action) => {
  switch (action.type) {
    /*以下为 tim sdk */

    case TIMSDK_DATA_DYNAMIC_UPDATE:
    case NIMSDK_DATA_DYNAMIC_UPDATE:
      const { payload = {} } = action;
      return {
        ...state,
        ...payload,
      };

    case TIMSDK_LOGOUT: {
      return {
        ...state,
        timIsReady: false,
        timIsGroupReady: false,
        timGroupChat: {
          list: [],
          groupPhotoList: [],
          isMore: false,
          lastMessageTime: '',
        },
      };
    }
    case TIMSDK_UPDATE_CONFIG: {
      const { payload = {} } = action;
      return {
        ...state,
        timSdkConfig: {
          ...state.timSdkConfig,
          ...payload,
        },
      };
    }
    case NIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST:
    case TIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST:
      const { data: { list = [], isMore = false, nextReqMessageID = '', ...other } = {} } = action;
      const { list: prevList = [], groupPhotoList: prevPhotoList = [] } = state.timGroupChat;
      let currentList = list.map((k) => parseFromConversion(k, k.type));
      let currentPhotoList = currentList.filter((k) => isImageTypeMsg(k)).map((k) => parseCustomImageConversion({ ...k, source: k.url }));
      return {
        ...state,
        triggerScroll: !prevList.length ? true : state.triggerScroll,
        timGroupChat: {
          ...state.timGroupChat,
          list: [...currentList, ...prevList],
          groupPhotoList: [...currentPhotoList, ...prevPhotoList],
          isMore,
          nextReqMessageID,
          ...other,
        },
      };
    //插入一条消息
    case NIMSDK_RECEIVEMESSAGE:
    case TIMSDK_RECEIVEMESSAGE: {
      const { data: { list = [], triggerScroll = false } = {} } = action;
      const { list: prevList = [], groupPhotoList: prevPhotoList = [] } = state.timGroupChat;
      let currentList = list.map((k) => parseFromConversion(k, k.type));
      let currentPhotoList = currentList.filter((k) => isImageTypeMsg(k)).map((k) => parseCustomImageConversion({ ...k, source: k.url }));

      return {
        ...state,
        triggerScroll,
        timGroupChat: {
          ...state.timGroupChat,
          list: [...prevList, ...currentList],
          groupPhotoList: [...prevPhotoList, ...currentPhotoList],
        },
      };
    }
    //是否滚动到底部
    case TIMSDK_RECEIVE_MESSAGE_SCROLL: {
      const { payload } = action;
      return {
        ...state,
        triggerScroll: payload,
      };
    }
    //更新某条消息的发送状态
    case TIMSDK_UPDATE_MESSAGE_STATUS: {
      const { payload } = action;
      let { list = [] } = state.timGroupChat;
      if (!(payload.id || payload.clientSequence)) {
        return {
          ...state,
        };
      }
      return {
        ...state,
        timGroupChat: {
          ...state.timGroupChat,
          list: list.map((k) => ((k.id && k.id == payload.id) || (k.clientSequence && k.clientSequence == payload.clientSequence) ? { ...k, ...payload } : k)),
        },
      };
    }

    default: {
      return state;
    }
  }
};

export { reducer as ImsReducer };
